import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FontDownloadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"font_download"}/>
}
